import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../../axios/axios";

export const fetchCountryPrices = createAsyncThunk(
  "fetchCountryPrices",
  async () => {
    try {
      const { data } = await getRequest("/api/v1/plan-price");

      if (data.status === "success") {
        return {
          priceMonthly: data.data.priceMonthly,
          priceYearly: data.data.priceYearly,
        };
      }
    } catch (err) {
      throw err.response ? err.response.data.message : err.message;
    }
  }
);
